import {MessageBag} from "@/v2/models/message-bag.js";
import { capitalize } from "@/v2/utils/string";

export default {
    data() {
        return {
            messageBag: new MessageBag(),
        }
    },
    methods: {
        displayMessages(title = null, buttonClass = '', redirectUrl = null, callback = null) {
            if (!this.messageBag.isEmpty()) {
                alert("<p>" + this.messageBag.getAll().join("</p><p>") + "</p>", title, buttonClass, redirectUrl, callback);
                this.messageBag.empty();
            }
        },
        handleRepositoryValidationError(error) {
            for (let key in error.response.data?.errors?.data ?? {}) {
                for (let error of error.response.data.errors.data[key]) {
                    let message = null;
                    switch (error) {
                        case 'validation.unique':
                           message = `${capitalize(key)} already exists.`;
                           break;
                        case 'validation.required':
                           message = `${capitalize(key)} is required.`;
                           break;
                        default:
                            message = `${capitalize(key)} does not satisfy. ${error}`;
                            break;
                    }
                    this.messageBag.add(`repository_validation_error_${key}_${error}`, message);
                }
            }

            if ((error.response.data?.errors?.data ?? null) == null) {
                this.messageBag.empty();
            } else {
                this.displayMessages();
            }
        }
    }
}
